// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SEND_SERVICE } from '../../../../services/send.service';

@Injectable({
  providedIn: 'root',
})
export class TableFieldService {
  readonly sendService = inject(SEND_SERVICE);

  public getDinamicUrl<T>(url, params): Observable<T> {
    return this.sendService.get(url, { params });
  }

  public postDinamicUrl<T>(url, body, params): Observable<T> {
    return this.sendService.post(url, body, { params });
  }

  public putDinamicUrl<T>(url, body, params): Observable<T> {
    return this.sendService.put(url, body, { params });
  }
}
